import { DownloadAppBlade } from '../DownloadAppBlade/DownloadAppBlade';
import { RestrictedNotification } from './RestrictedNotification';

export const RestrictedHomeView = () => {
  return (
    <>
      <RestrictedNotification />
      <DownloadAppBlade />
    </>
  );
};
